<form
  (submit)="onSubmit()"
  [formGroup]="form"
  class="form-horizontal m-3 transfer-form"
>
  <p class="action-button-wrapper">
    <button class="btn btn-primary" type="submit">Speichern</button>
  </p>

  <p-tabs value="Allgemein">
    <p-tablist>
      <p-tab value="Allgemein">
        Allgemein
        <app-error-badge group="main"></app-error-badge>
      </p-tab>
      <p-tab *ngIf="certificatesLoaded" value="Anfrage-Zertifikate">
        Anfrage-Zertifikate
      </p-tab>
    </p-tablist>

    <p-tabpanels>
      <p-tabpanel value="Allgemein">
        <div class="card">
          <div class="card-header">
            Allgemeine Daten
          </div>
          <div class="card-body" formGroupName="main">
            <app-form-group
              [group]="main"
              control="name"
              label="Name"
            >
              <input
                id="name"
                type="text"
                placeholder="Name"
                formControlName="name"
                class="form-control"
              />
            </app-form-group>
            <app-form-group
              [group]="main"
              control="description"
              label="Beschreibung"
            >
              <input
                id="description"
                type="text"
                placeholder="Beschreibung"
                formControlName="description"
                class="form-control"
              />
            </app-form-group>

          </div>
        </div>
      </p-tabpanel>
      <p-tabpanel *ngIf="certificatesLoaded" value="Anfrage-Zertifikate">
        <app-certificate-selection-list
          title="Anfrage-Zertifikate"
          [data]="certificates"
          [storageData]="getStorageData('allowedCerts')"
          (addedCertificateSelected)="addSelectedCertificate($event)"
          (removeCertificateSelected)="removeSelectedCertificate($event)"
          (clickOnNew)="setClickOnNew()"
        ></app-certificate-selection-list>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</form>
